// extracted by mini-css-extract-plugin
export default {"storageAccess":"StorageAccess-module__storageAccess___2-b7k"};